import { useCallback, useEffect, useState } from "react";
import { apiUrl } from "utils/apiUrl";
import { clientSafeMessage } from "utils/clientSafeMessage";

/**
 * Authoritative 1st-month risk locks from Supabase (admin Active/Inactive).
 */
export function useFirstMonthRiskLocks(effectiveClientId) {
  const [locks, setLocks] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    if (!effectiveClientId) {
      setLocks({});
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await fetch(apiUrl("/api/client/first-month-risk-locks"), {
        credentials: "include",
        cache: "no-store",
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.ok) {
        throw new Error(
          clientSafeMessage(data.message, "Could not load account settings."),
        );
      }
      setLocks(data.locks && typeof data.locks === "object" ? data.locks : {});
    } catch (e) {
      setError(clientSafeMessage(e?.message, "Could not load account settings."));
      setLocks({});
    } finally {
      setLoading(false);
    }
  }, [effectiveClientId]);

  useEffect(() => {
    void reload();
  }, [reload]);

  useEffect(() => {
    const onFocus = () => void reload();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [reload]);

  return { locks, loading, error, reload };
}
